import Home from '../components/home';

function Index() {
  return <Home />;
}

export default Index;
